import { render, staticRenderFns } from "./trendList.vue?vue&type=template&id=50c148b4&scoped=true"
import script from "./trendList.vue?vue&type=script&lang=js"
export * from "./trendList.vue?vue&type=script&lang=js"
import style0 from "./trendList.vue?vue&type=style&index=0&id=50c148b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c148b4",
  null
  
)

export default component.exports